import { Card, Input } from "antd";
import React, { useContext, useEffect, useState } from "react";
import FetchContext from "../../../contexts/fetch";
import { DynamicForm } from "../../DynamicForm";
import EdgeList from "../Flow/EdgeList";
import styles from "../manager.module.css";

const Edge = ({ edgeData, setEdgeData }) => {
  const [config] = useContext(FetchContext);

  const [edgeConfig, setEdgeConfig] = useState({
    type: "code",
    language: "json",
    windowSize: "large",
  });

  useEffect(() => {
    if (config.clientConfig?.edge) {
      setEdgeConfig(config.clientConfig.edge);
    }
  }, [config.clientConfig]);

  const handleConditionChange = (value) => {
    setEdgeData({
      ...edgeData,
      data: value,
    });
  };

  const handleLabelChange = function (e) {
    setEdgeData({
      ...edgeData,
      label: e.target.value,
    });
  };

  return edgeData ? (
    <div>
      <div className={styles.header}>
        <Card
          className={styles.section}
          title={<span className={styles.section_title}>Condition Name</span>}
          bordered={false}
          style={{ width: 300 }}
        >
          <Input
            type="text"
            data-key="name"
            value={edgeData.label}
            onChange={handleLabelChange}
          />
        </Card>
      </div>
      <DynamicForm
        formData={edgeData.data}
        onParameterChange={handleConditionChange}
        parametersModel={{
          condition: {
            type: "code",
            language: edgeConfig.language,
            windowSize: edgeConfig.windowSize,
          },
        }}
        utilsData={[{}, () => {}]}
      />
    </div>
  ) : (
    <div className={styles.edge_list_container}>
      <Card
        className={styles.section}
        title={
          <span className={styles.section_title}>Choisir un lien à éditer</span>
        }
      >
        <EdgeList />
      </Card>
    </div>
  );
};

export default Edge;
